import React, { useEffect, useState } from "react";
import {
  Button,
  Card,
  CardBody,
  Col,
  Container,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
  Row,
} from "reactstrap";

import { useDispatch, useSelector } from "react-redux";
import BreadCrumb from "../../../Components/Common/BreadCrumb";
import Pagination from "../../../Components/Common/Pagination";
import {
  getPackages,
  addPackage,
  updatePackage,
  deletePackage,
} from "../../../slices/7-package/thunk";
import MediaLibraryModal from "../../0-Media/MediaLibraryModal";
import PackageViewModal from "./PackageViewModal";

const StoreTable = () => {
  const dispatch = useDispatch();

  // ─── State ─────────────────────────────
  const [modalAdd, setModalAdd] = useState(false);
  const [modalEdit, setModalEdit] = useState(false);
  const [deleteModal, setDeleteModal] = useState(false);

  const [selectedId, setSelectedId] = useState(null);
  const [currentPackage, setCurrentPackage] = useState(null);

  const [name, setName] = useState("");
  const [icon, setIcon] = useState("");
  const [isActive, setIsActive] = useState(true);
  const [isFeatured, setIsFeatured] = useState(false);
  const [sortOrder, setSortOrder] = useState(1);
  const [coins, setCoins] = useState("");
  const [price, setPrice] = useState("");
  const [viewModal, setViewModal] = useState(false);
  const [selectedPackage, setSelectedPackage] = useState(null);

  const [searchTerm, setSearchTerm] = useState("");
  const [page, setPage] = useState(1);
  const limit = 10;
  const [errors, setErrors] = useState({});

  const { packages, totalPages } = useSelector((state) => state.Packages);

  const [image, setImage] = useState("");
  const [mediaModal, setMediaModal] = useState(false);

  useEffect(() => {
    dispatch(getPackages({ page, limit, search: searchTerm }));
  }, [dispatch, page, searchTerm]);

  // ─── Reset form ────────────────────────
  const resetForm = () => {
    setName("");
    setCoins("");
    setPrice("");
    setImage("");
    setSortOrder(1);
    setIsActive(true);
    setIsFeatured(false);
    setCurrentPackage(null);
    setSelectedId(null);
    setErrors({});
  };

  // ─── ADD ───────────────────────────────
  const handleAdd = (e) => {
    e.preventDefault();

    if (!validateForm()) return;

    dispatch(
      addPackage({
        name,
        coins: Number(coins),
        price: Number(price),
        icon: image,
        isActive,
        isFeatured,
        sortOrder: Number(sortOrder),
      }),
    );

    dispatch(getPackages({ page, limit, search: searchTerm }));
    setModalAdd(false);
    resetForm();
  };

  // ─── EDIT ──────────────────────────────
  const openEdit = (item) => {
    setCurrentPackage(item);

    setName(item.name);
    setCoins(item.coins);
    setPrice(item.price);
    setIcon(item.icon || "");
    setIsActive(item.isActive);
    setIsFeatured(item.isFeatured);
    setSortOrder(item.sortOrder || 1);

    setModalEdit(true);
  };

  const handleEdit = (e) => {
    e.preventDefault();

    if (!validateForm()) return;

    dispatch(
      updatePackage({
        id: currentPackage._id,
        data: {
          name,
          coins: Number(coins),
          price: Number(price),
          icon: image,
          isActive,
          isFeatured,
          sortOrder: Number(sortOrder),
        },
      }),
    );

    dispatch(getPackages({ page, limit, search: searchTerm }));
    setModalEdit(false);
    resetForm();
  };

  // ─── DELETE ────────────────────────────
  const handleDelete = () => {
    dispatch(deletePackage(selectedId));
    dispatch(getPackages({ page, limit, search: searchTerm }));
    setDeleteModal(false);
  };

  const openViewModal = (item) => {
    setSelectedPackage(item);
    setViewModal(true);
  };

  const validateForm = () => {
    const newErrors = {};

    if (!name.trim()) {
      newErrors.name = "اسم الباقة مطلوب";
    }

    if (!coins || Number(coins) < 1) {
      newErrors.coins = "عدد الكوينز لازم يكون 1 على الأقل";
    }

    if (!price || Number(price) < 1) {
      newErrors.price = "السعر لازم يكون 1 على الأقل";
    }

    if (!image) {
      newErrors.image = "الصورة مطلوبة";
    }

    if (!sortOrder || Number(sortOrder) < 1) {
      newErrors.sortOrder = "ترتيب العرض لازم يكون 1 على الأقل";
    }

    setErrors(newErrors);

    return Object.keys(newErrors).length === 0;
  };

  // console.log(packages);
  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <BreadCrumb title="إدارة الباقات" />

          <Row>
            <Col lg={12}>
              <Card>
                <CardBody>
                  {/* Search + Add */}
                  <Row className="mb-3">
                    <Col>
                      <input
                        className="form-control"
                        placeholder="بحث..."
                        value={searchTerm}
                        onChange={(e) => setSearchTerm(e.target.value)}
                      />
                    </Col>

                    <Col className="text-end">
                      <Button
                        color="success"
                        onClick={() => {
                          resetForm();
                          setModalAdd(true);
                        }}
                      >
                        إضافة باقة
                      </Button>
                    </Col>
                  </Row>

                  {/* Table */}
                  <div className="table-responsive">
                    <table className="table text-center">
                      <thead>
                        <tr>
                          <th>اسم الباقة</th>
                          <th>الكوينز</th>
                          <th> السعر (ج.م)</th>
                          <th>إجراءات</th>
                        </tr>
                      </thead>

                      <tbody>
                        {packages.length > 0 ? (
                          packages.map((item) => (
                            <tr key={item._id}>
                              <td>{item.name}</td>
                              <td>{item.coins}</td>
                              <td>{item.price}</td>

                              <td>
                                <div className="d-flex gap-2 justify-content-center">
                                  {/* Edit */}
                                  <div>
                                    <button
                                      className="btn btn-sm"
                                      style={{
                                        padding: "0px",
                                        background: "transparent",
                                        border: "none",
                                      }}
                                      onClick={() => openEdit(item)}
                                    >
                                      <i
                                        className="ri-edit-line"
                                        style={{
                                          color: "gray",
                                          fontSize: "20px",
                                        }}
                                      />
                                    </button>
                                  </div>

                                  {/* Delete */}
                                  <div>
                                    <button
                                      className="btn btn-sm"
                                      style={{
                                        padding: "0px",
                                        background: "transparent",
                                        border: "none",
                                      }}
                                      onClick={() => {
                                        setSelectedId(item._id);
                                        setDeleteModal(true);
                                      }}
                                    >
                                      <i
                                        className="ri-delete-bin-line"
                                        style={{
                                          color: "#dc3545",
                                          fontSize: "20px",
                                        }}
                                      />
                                    </button>
                                  </div>

                                  {/* View */}
                                  <button
                                    style={{
                                      background: "transparent",
                                      border: "none",
                                    }}
                                    onClick={() => openViewModal(item)}
                                  >
                                    <i
                                      className="ri-eye-line"
                                      style={{
                                        fontSize: "20px",
                                        color: "#3498db",
                                      }}
                                    ></i>
                                  </button>
                                </div>
                              </td>
                            </tr>
                          ))
                        ) : (
                          <tr>
                            <td colSpan="4">لا يوجد باقات</td>
                          </tr>
                        )}
                      </tbody>
                    </table>
                  </div>

                  {/* Pagination */}
                  <div className="row g-0 text-center text-sm-start align-items-center mb-4">
                    <div className="col-sm-6"></div>
                    <div className="col-sm-6">
                      <Pagination
                        currentPage={page}
                        totalPages={totalPages}
                        onPageChange={(newPage) => {
                          setPage(newPage);
                          window.scrollTo({
                            top: 0,
                            behavior: "smooth",
                          });
                        }}
                      />
                    </div>
                  </div>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>

      {/* ───────── ADD ───────── */}
      <Modal
        isOpen={modalAdd}
        toggle={() => {
          setModalAdd(false);
          resetForm();
        }}
        centered
      >
        <ModalHeader toggle={() => setModalAdd(false)}>
          إضافة باقة جديدة
        </ModalHeader>

        <form onSubmit={handleAdd}>
          <ModalBody>
            <div className="mb-3">
              <label className="form-label">اسم الباقة</label>
              <input
                type="text"
                className="form-control"
                value={name}
                onChange={(e) => setName(e.target.value)}
                required
              />
            </div>

            <div className="mb-3">
              <label className="form-label">عدد الكوينز</label>
              <input
                type="number"
                className="form-control"
                value={coins}
                min="1"
                onChange={(e) => {
                  const value = Math.max(1, Number(e.target.value));
                  setCoins(value);
                }}
                required
              />
              {errors.coins && (
                <small className="text-danger">{errors.coins}</small>
              )}
            </div>

            <div className="mb-3">
              <label className="form-label">السعر</label>
              <input
                type="number"
                className="form-control"
                value={price}
                min="1"
                onChange={(e) => {
                  const value = Math.max(1, Number(e.target.value));
                  setPrice(value);
                }}
                required
              />
              {errors.price && (
                <small className="text-danger">{errors.price}</small>
              )}
            </div>

            <div className="mb-3">
              <label className="form-label">الصورة</label>

              <div className="msq-upload" onClick={() => setMediaModal(true)}>
                {image ? (
                  <img
                    src={image}
                    alt="preview"
                    style={{ width: "100%", borderRadius: 8 }}
                  />
                ) : (
                  <>
                    <span>📷</span>
                    <span>اضغط لرفع صورة</span>
                  </>
                )}
                {errors.image && (
                  <small className="text-danger d-block mt-2">
                    {errors.image}
                  </small>
                )}
              </div>
            </div>

            <div className="mb-3">
              <label className="form-label">ترتيب العرض</label>
              <input
                type="number"
                className="form-control"
                value={sortOrder}
                onChange={(e) => {
                  const value = Math.max(1, Number(e.target.value));
                  setSortOrder(value);
                }}
              />
              {errors.sortOrder && (
                <small className="text-danger">{errors.sortOrder}</small>
              )}
            </div>

            <div className="form-check mb-2">
              <input
                type="checkbox"
                className="form-check-input"
                checked={isActive}
                onChange={() => setIsActive(!isActive)}
              />
              <label className="form-check-label">مفعلة</label>
            </div>

            <div className="form-check">
              <input
                type="checkbox"
                className="form-check-input"
                checked={isFeatured}
                onChange={() => setIsFeatured(!isFeatured)}
              />
              <label className="form-check-label">مميزة</label>
            </div>
          </ModalBody>

          <ModalFooter>
            <button
              className="btn btn-light"
              onClick={() => setModalAdd(false)}
            >
              إلغاء
            </button>
            <button type="submit" className="btn btn-success">
              حفظ
            </button>
          </ModalFooter>
        </form>
      </Modal>

      {/* ───────── EDIT ───────── */}
      <Modal
        isOpen={modalEdit}
        toggle={() => {
          setModalEdit(false);
          resetForm();
        }}
        centered
      >
        <ModalHeader toggle={() => setModalEdit(false)}>
          تعديل الباقة
        </ModalHeader>

        <form onSubmit={handleEdit}>
          <ModalBody>
            <div className="mb-3">
              <label className="form-label">اسم الباقة</label>
              <input
                type="text"
                className="form-control"
                value={name}
                onChange={(e) => setName(e.target.value)}
                required
              />
            </div>

            <div className="mb-3">
              <label className="form-label">عدد الكوينز</label>
              <input
                type="number"
                className="form-control"
                value={coins}
                min="1"
                onChange={(e) => {
                  const value = Math.max(1, Number(e.target.value));
                  setCoins(value);
                }}
                required
              />
            </div>

            <div className="mb-3">
              <label className="form-label">السعر</label>
              <input
                type="number"
                className="form-control"
                value={price}
                min="1"
                onChange={(e) => {
                  const value = Math.max(1, Number(e.target.value));
                  setPrice(value);
                }}
                required
              />
            </div>

            <div className="mb-3">
              <label className="form-label">الصورة</label>

              <div className="msq-upload" onClick={() => setMediaModal(true)}>
                {image ? (
                  <img
                    src={image}
                    alt="preview"
                    style={{ width: "100%", borderRadius: 8 }}
                  />
                ) : (
                  <>
                    <span>📷</span>
                    <span>اضغط لرفع صورة</span>
                  </>
                )}
              </div>
            </div>

            <div className="mb-3">
              <label className="form-label">ترتيب العرض</label>
              <input
                type="number"
                className="form-control"
                value={sortOrder}
                min="1"
                onChange={(e) => {
                  const value = Math.max(1, Number(e.target.value));
                  setSortOrder(value);
                }}
              />
            </div>

            <div className="form-check mb-2">
              <input
                type="checkbox"
                className="form-check-input"
                checked={isActive}
                onChange={() => setIsActive(!isActive)}
              />
              <label className="form-check-label">مفعلة</label>
            </div>

            <div className="form-check">
              <input
                type="checkbox"
                className="form-check-input"
                checked={isFeatured}
                onChange={() => setIsFeatured(!isFeatured)}
              />
              <label className="form-check-label">مميزة</label>
            </div>
          </ModalBody>

          <ModalFooter>
            <button className="btn btn-primary">حفظ التعديلات</button>
          </ModalFooter>
        </form>
      </Modal>

      {/* ───────── DELETE ───────── */}
      <Modal isOpen={deleteModal} toggle={() => setDeleteModal(false)} centered>
        <ModalHeader toggle={() => setDeleteModal(false)}>
          تأكيد الحذف
        </ModalHeader>

        <ModalBody>
          <div className="mt-2 text-center">
            <i className="ri-delete-bin-line display-3 text-danger"></i>

            <div className="mt-4 pt-2 fs-15 mx-4">
              <h4>هل أنت متأكد؟</h4>
              <p className="text-muted">هل تريد حذف هذه الباقة؟</p>
            </div>
          </div>
        </ModalBody>

        <ModalFooter>
          <div className="hstack gap-2 justify-content-center w-100">
            <Button color="light" onClick={() => setDeleteModal(false)}>
              إلغاء
            </Button>
            <Button color="danger" onClick={handleDelete}>
              حذف
            </Button>
          </div>
        </ModalFooter>
      </Modal>

      <MediaLibraryModal
        isOpen={mediaModal}
        onClose={() => setMediaModal(false)}
        onSelect={(url) => {
          setImage(url);
          setMediaModal(false);
        }}
        multi={false}
        showTabs={{ images: true }}
      />

      <PackageViewModal
        isOpen={viewModal}
        toggle={() => setViewModal(false)}
        data={selectedPackage}
      />
    </React.Fragment>
  );
};

export default StoreTable;
